

import axios from 'axios';

  const URL = "https://api-inference.huggingface.co/models/facebook/bart-large-cnn";

  export async function summarizeTextAPI(text, minLength,maxLength) {
    try {
      const data = JSON.stringify({
        "inputs": text,
        "parameters": {
          "max_length": maxLength,
          "min_length": minLength
        }
      });

      const response = await axios.post(URL, data, {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_HUGGINGFACE_API_KEY}`,
          'Content-Type': 'application/json'
        }
      });

      console.log(response.data[0]);
      return response?.data[0]?.summary_text;
    } catch (error) {
      console.error('Error summarizing text:', error);
      return null;
    }
  }


  // "parameters":{
  //     "max_length":100,
  //     "min_length":30
  // }